import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ConnectOrganisationPriceListMutationVariables = Types.Exact<{
  priceListId: Types.Scalars['ID'];
}>;


export type ConnectOrganisationPriceListMutation = { readonly __typename?: 'Mutation', readonly priceListV2: { readonly __typename?: 'PriceListV2Mutations', readonly connectOrganisationPriceList: { readonly __typename?: 'ConnectOrganisationPriceListResponse', readonly organisationPriceListId: string } } };


export const ConnectOrganisationPriceListDocument = gql`
    mutation connectOrganisationPriceList($priceListId: ID!) {
  priceListV2 {
    connectOrganisationPriceList(input: {priceListId: $priceListId}) {
      organisationPriceListId
    }
  }
}
    `;
export type ConnectOrganisationPriceListMutationFn = Apollo.MutationFunction<ConnectOrganisationPriceListMutation, ConnectOrganisationPriceListMutationVariables>;

/**
 * __useConnectOrganisationPriceListMutation__
 *
 * To run a mutation, you first call `useConnectOrganisationPriceListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectOrganisationPriceListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectOrganisationPriceListMutation, { data, loading, error }] = useConnectOrganisationPriceListMutation({
 *   variables: {
 *      priceListId: // value for 'priceListId'
 *   },
 * });
 */
export function useConnectOrganisationPriceListMutation(baseOptions?: Apollo.MutationHookOptions<ConnectOrganisationPriceListMutation, ConnectOrganisationPriceListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectOrganisationPriceListMutation, ConnectOrganisationPriceListMutationVariables>(ConnectOrganisationPriceListDocument, options);
      }
export type ConnectOrganisationPriceListMutationHookResult = ReturnType<typeof useConnectOrganisationPriceListMutation>;
export type ConnectOrganisationPriceListMutationResult = Apollo.MutationResult<ConnectOrganisationPriceListMutation>;
export type ConnectOrganisationPriceListMutationOptions = Apollo.BaseMutationOptions<ConnectOrganisationPriceListMutation, ConnectOrganisationPriceListMutationVariables>;